import React from 'react';
import PropTypes from 'prop-types';

const CheckIcon = ({ size = 16, color = '#0E6928' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" fill="none">
    <g clipPath="url(#clip0_106_3439)">
      <path fillRule="evenodd" clipRule="evenodd" d="M7.99996 0.666664C3.94987 0.666664 0.666626 3.94991 0.666626 8C0.666626 12.0501 3.94987 15.3333 7.99996 15.3333C12.05 15.3333 15.3333 12.0501 15.3333 8C15.3333 3.94991 12.05 0.666664 7.99996 0.666664ZM11.4714 6.4714C11.7317 6.21105 11.7317 5.78894 11.4714 5.52859C11.211 5.26824 10.7889 5.26824 10.5286 5.52859L6.99996 9.0572L5.47137 7.5286C5.21101 7.26826 4.78891 7.26826 4.52855 7.5286C4.26821 7.78893 4.26821 8.21106 4.52855 8.4714L6.52855 10.4714C6.78889 10.7317 7.21103 10.7317 7.47136 10.4714L11.4714 6.4714Z" fill={color} />
    </g>
    <defs>
      <clipPath id="clip0_106_3439">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

CheckIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

export default CheckIcon;
